import React from 'react';

export const TutorialVideoPlayer = ({ video }) => {
    const url = video?.file?.url;

    return (
        <div className="tutorial-video-player">
            {url ? (
                <video src={url} width="100%" height="100%" controls autoPlay controlsList="nodownload" />
            ) : (
                <p className="tutorial-video-player-error">This video could not be loaded. Please refresh and try again.</p>
            )}
        </div>
    );
};
